import React, { useRef, useState } from "react"
import { Form, Button, Card, Alert } from "react-bootstrap"
import { useAuth } from "../../contexts/AuthContext"
import { Link, useHistory } from "react-router-dom"
import CenteredContainer from "./CenteredContainer"

export default function Login() {
  const emailRef = useRef()
  const passwordRef = useRef()
  const { login } = useAuth()
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  async function handleSubmit(e) {
    e.preventDefault()

    try {
      setError("")
      setLoading(true)
      await login(emailRef.current.value, passwordRef.current.value)
      history.push("/")
    } catch {
      setError("Failed to log in")
    }

    setLoading(false)

  }

  return (
<body style={{backgroundImage: "url(https://www.czechmtm.cz/bg.png)"}}>
<CenteredContainer>
      <Card style={{boxShadow: "3px 3px 3px #5c5c5c"}}  >
        <Card.Body>
          <h2 className="text-center mb-4"><img src="https://www.czechmtm.cz/logo-drive.png" alt="mtm-drive" width="350" height="auto"></img></h2>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group id="email">
              <Form.Label>Uživatelské jméno</Form.Label>
              <Form.Control type="email" ref={emailRef} required />
            </Form.Group>
            <Form.Group id="password">
              <Form.Label>Heslo</Form.Label>
              <Form.Control type="password" ref={passwordRef} required />
            </Form.Group>
            <Button disabled={loading} className="w-100" type="submit">
              Přihlásit
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </CenteredContainer>
  </body>

  )
}
